require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-understanding-gender-gapin-investing.json") })
        }
      }, "path---insights-understanding-gender-gapin-investing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-understanding-gender-gapin-investing!./.cache/json/insights-understanding-gender-gapin-investing.json
// module id = 1131
// module chunks = 231608221292675